import { Col, Container, Row } from "react-bootstrap";
import NavBar from "../../Navbar/Navbar";
import "./Consultancy.css";
import EmiratesNBD from "../../../assets/logos/Emirates-NBD.png";
import ApparelGroup from "../../../assets/logos/Apparel-Group.png";
import Tanfeeth from "../../../assets/logos/Tanfeeth.png";
import HyattRegency from "../../../assets/logos/Hyatt-Regency.png";
import JumerahCreeckside from "../../../assets/logos/Jumerah-Creeckside.png";
import HSBC from "../../../assets/logos/HSBC.png";
import ClydeCo from "../../../assets/logos/Clyde-Co.png";
import Rotana from "../../../assets/logos/Rotana.png";
import Transworld from "../../../assets/logos/Transworld.png";
import Emrill from "../../../assets/logos/Emrill.png";

import TMS from "../../../assets/logos/TMS.png";
import GEMS from "../../../assets/logos/GEMS.png";
import DubaiScholars from "../../../assets/logos/Dubai-scholars.png";
import AmityUniversity from "../../../assets/logos/Amity-University.png";
import MiddlesexUni from "../../../assets/logos/Middlesex-Uni.png";
import Repton from "../../../assets/logos/Repton.png";
import Footer from "../../Footer/Footer";
import un from "../../../assets/img/No_Image_Available.jpg";


import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Helmet } from "react-helmet";
export default function Consultancy() {
  return (
    <>
      <Helmet>
        <title>
          Consultancy | Manzil Center -Special Families Support | Sharjah
        </title>
        <meta
          name="description"
          content="Manzi Center has worked with over 275 companies spanning DEI assessments, DEI strategy & policy compliance, and employment-related services."
        />
        <meta name="keywords" content="Manzil center, Special Family Support, Educational and Corporate consultancy, special need school, Autism Center in Sharjah, NGO in Sharjah, Sharjah, UAE, special EMPLOYMENT PROGRAM in sharjah" />
        <link rel="canonical" href="https://www.manzil.ae/consultancy" />
        <meta
          property="og:title"
          content="Consultancy | Manzil Center -Special Families Support | Sharjah"
        />
        <meta
          property="og:description"
          content="Manzi Center has worked with over 275 companies spanning DEI assessments, DEI strategy & policy compliance, and employment-related services."
        />
        <meta property="og:url" content="https://www.manzil.ae/consultancy" />
        <meta
          name="twitter:title"
          content="Consultancy | Manzil Center -Special Families Support | Sharjah"
        />
        <meta
          name="twitter:description"
          content="Manzi Center has worked with over 275 companies spanning DEI assessments, DEI strategy & policy compliance, and employment-related services."
        />
      </Helmet>
      <NavBar />
      <div className="page-title-area consul-inner">
        <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
          <div className="page-title-content">
            <ul>
              {/* <li>
                <a href="/">Home</a>
              </li> */}
              <li>
                <h1>Consultancy </h1>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Container className="mt-4 pt-2">
        <Row>
          {/* <Col lg={12} className="text-center">
            <div className="main-heading">
               <span className="center">Consultancy</span> 
              <p>
                We work closely with corporate as well as educational
                institutions across different areas. Some of our key initiatives
                and clients are shared below:
              </p>
            </div>
          </Col> */}
          <Col lg={12} className="text-center">
            <div className="main-heading">
              <span className="center">Designing Inclusive Systems that Work—For People, Performance, and Progress</span>
              <p>
                At Manzil, we specialise in helping organisations and schools build ecosystems where people of determination, neurodivergent individuals, and those with diverse needs can thrive, not just be included.
                From short-term accommodations to long-term systemic change, and even tailored job consultancy services, we guide you in embedding accessibility, dignity, and practicality into every layer of your operations. Our approach isn't about ticking boxes, creating spaces that drive better outcomes, reduce friction, and support every individual's potential.
              </p>
            </div>
          </Col>
          <Col lg={12}>
            <div className="main-heading">
              {/* <span>Corporate Consultancy</span> */}
              <span>Corporate Inclusion Consultancy</span>
              {/* <p>
                We have worked with over 275 companies spanning DEI assessments,
                DEI strategy & policy compliance, employment related services
                (Internships, job matching, job coaching, WFH training, staff
                training etc) and well-being / stress management workshops
              </p> */}
              <p>Future-Proofing Workplaces with Inclusion-First Thinking</p>
            </div>
            {/* <Row> */}
            {/* <Swiper
              slidesPerView={1}
              loop={true}
              spaceBetween={10}
              pagination={false}
              navigation={true}
             
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation, Pagination]}
              className="mySwiper pt-3 client-swiper">
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={EmiratesNBD}
                    className="img-fluid"
                    alt="Emirates NBD"
                  />
                  <p>Emirates NBD</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={ApparelGroup}
                    className="img-fluid"
                    alt="Apparel Group"
                  />
                  <p>Apparel Group</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={Tanfeeth} className="img-fluid" alt="Tanfeeth" />
                  <p>Tanfeeth</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={HyattRegency}
                    className="img-fluid"
                    alt="Hyatt Regency"
                  />
                  <p>Hyatt Regency</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={JumerahCreeckside}
                    className="img-fluid"
                    alt="Jumerah Creeckside"
                  />
                  <p>Jumerah Creeckside</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={HSBC} className="img-fluid" alt="HSBC" />
                  <p>HSBC</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={ClydeCo} className="img-fluid" alt="Clyde & Co" />
                  <p>Clyde & Co</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={Rotana} className="img-fluid" alt="Rotana" />
                  <p>Rotana</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={Transworld}
                    className="img-fluid"
                    alt="Transworld"
                  />
                  <p>Transworld</p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={Emrill} className="img-fluid" alt="Emrill" />
                  <p>Emrill</p>
                </div>
              </SwiperSlide>
            </Swiper> */}


            {/* </Row> */}
          </Col>
          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={un}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="consultancy-content">
                <h5 className="mb-2">
                  <span>Tap into untapped talent</span>
                </h5>
                <p className="mb-2">Redesign recruitment, onboarding, and job roles to attract and retain neurodivergent and disability-confident candidates, turning inclusion into a strategic advantage.
                </p>

              </div>
            </div>


          </div>

          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={un}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="consultancy-content">
                <h5 className="mb-2">
                  <span>Support employees through every ability and stage</span>
                </h5>
                <p className="mb-2">Create agile, compliant systems that accommodate temporary or long-term disabilities without sacrificing performance or continuity.
                </p>

              </div>
            </div>


          </div>

          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={un}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="consultancy-content">
                <h5 className="mb-2">
                  <span>Make every space work for everyone</span>
                </h5>
                <p className="mb-2"> Our audits of physical and digital environments aligned with the UAE’s Universal Design Code identify smart fixes that reduce future retrofitting and ensure usability for all.
                </p>

              </div>
            </div>


          </div>

          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={un}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="consultancy-content">
                <h5 className="mb-2">
                  <span>Build wellness programs that actually include everyone</span>
                </h5>
                <p className="mb-2"> Go beyond generic wellness. We design strategies for sensory regulation, flexible routines, and communication preferences for neurodivergent and disabled staff.
                </p>

              </div>
            </div>


          </div>

          <div className="col-lg-4 mb-4">
            <div className="service-card">
              <img
                src={un}
                className="img-fluid top-rounded-img"
                alt="United Nations Zero Project Award"
              />
              <div className="consultancy-content">
                <h5 className="mb-2">
                  <span>Close the communication gap</span>
                </h5>
                <p className="mb-2"> Equip your teams with inclusive protocols, practical tools, and interpreter access so everyone can contribute meaningfully and confidently.
                </p>

              </div>
            </div>


          </div>




        </Row>
        <Row>
          <Col lg={12}>
            <div className="main-heading my-4">
              <span>Education Inclusion Consultancy</span>
              {/* <p>
                Baseline Assessments & SEND Program review, UDL for classroom
                learning, Mental health & Stress management, LSA training &
                Teacher capacity building workshops are some of the successful
                initiatives undertaken with about 15 institutions!
              </p> */}
              <p>Creating Learning Environments Where Every Student Belongs</p>
            </div>
          </Col>

          {/* <Col lg={12}>
            <Swiper
              slidesPerView={1}
              loop={true}
              spaceBetween={10}
              pagination={false}
              navigation={true}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 6,
                  spaceBetween: 50,
                },
              }}
              modules={[Navigation, Pagination]}
              className="mySwiper pt-3 client-swiper">
              <SwiperSlide>
                <div className="client-card">
                  <img src={TMS} className="img-fluid" alt="TMS" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={GEMS} className="img-fluid" alt="GEMS" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={DubaiScholars}
                    className="img-fluid"
                    alt="Dubai Scholars"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={AmityUniversity}
                    className="img-fluid"
                    alt="Amity University"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img
                    src={MiddlesexUni}
                    className="img-fluid"
                    alt="Middlesex Uni"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="client-card">
                  <img src={Repton} className="img-fluid" alt="Repton" />
                </div>
              </SwiperSlide>
            </Swiper>
          </Col> */}
          <Col lg={12}>
            <Row>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Make learning accessible for all</span>
                    </h5>
                    <p className="mb-2">We implement Universal Design for Learning (UDL) to ensure every student regardless of need can access and thrive within your curriculum.
                    </p>

                  </div>
                </div>


              </div>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Streamline support for students of determination</span>
                    </h5>
                    <p className="mb-2">Our simplified SEN systems ensure IEPs and accommodations are effective, timely, and aligned with your team's capacity.
                    </p>

                  </div>
                </div>


              </div>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Simplify progress tracking</span>
                    </h5>
                    <p className="mb-2">We introduce smart tools that reduce paperwork and bring clarity to decision-making improving outcomes for students and staff alike.
                    </p>

                  </div>
                </div>


              </div>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Equip teams for inclusive success</span>
                    </h5>
                    <p className="mb-2">Our training empowers LSAs and educators with practical strategies to confidently support students with sensory, cognitive, or physical differences.
                    </p>

                  </div>
                </div>


              </div>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Build a unified inclusion culture</span>
                    </h5>
                    <p className="mb-2">We co-create long-term strategies that align with compliance standards and make inclusion a measurable strength across your institution.
                    </p>

                  </div>
                </div>


              </div>
              <div className="col-lg-4 mb-4">
                <div className="service-card">
                  <img
                    src={un}
                    className="img-fluid top-rounded-img"
                    alt="United Nations Zero Project Award"
                  />
                  <div className="consultancy-content">
                    <h5 className="mb-2">
                      <span>Support every learner with personalized attention</span>
                    </h5>
                    <p className="mb-2">We offer tailored 1:1 services for students whether academic coaching, life skills, or emotional support, ensuring no learner is left behind.
                    </p>

                  </div>
                </div>


              </div>

            </Row>




          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
